import { createContext } from 'react';

const BillingContext = createContext();
export default BillingContext;
